<template>
    <el-table :data="data" :default-sort="{ prop: ORDER_MESSAGES.fields.createdAt, order: 'descending' }" class="w-100">
        <el-table-column type="expand">
            <template slot-scope="scope">
                <div class="row">
                    <div class="col-xl-12">
                        <p class="hint mb-1">Message Id</p>
                        <h6>{{ scope.row.id }}</h6>
                    </div>
                </div>
            </template>
        </el-table-column>
        <el-table-column label="Occurred" sortable prop="createdAt">
            <template slot-scope="scope">
                {{ `${getCreatedDate(scope.row[ORDER_MESSAGES.fields.createdAt])}` }}
            </template>
        </el-table-column>
        <el-table-column :prop="ORDER_MESSAGES.fields.message" label="Message"> </el-table-column>
    </el-table>
</template>
<script>
import { ORDER_MESSAGES } from 'db'
export default {
    props: {
        data: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
            ORDER_MESSAGES
        }
    },
    methods: {
        getCreatedDate(date) {
            return new Date(date).toLocaleString('en-US', {
                year: 'numeric',
                month: 'numeric',
                day: 'numeric',
                hour: 'numeric',
                minute: 'numeric'
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.el-table table .btn {
    margin: 0 5px;
}
</style>
